import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'antd';

class InputNumberWidget extends React.Component {
  static defaultProps = {
    value: undefined,
    placeholder: '',
    disabled: false,
  };

  static propTypes = {
    value: PropTypes.number,
    placeholder: PropTypes.string,
    required: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (!this.props.value && this.props.value !== 0 && this.props.value !== undefined) {
      this.props.onChange(undefined);
    }
  }

  componentWillReceiveProps(nextProp) {
    if (!nextProp.value && nextProp.value !== 0 && nextProp.value !== undefined) {
      this.props.onChange(undefined);
    }
  }

  onChange = (value) => {
    if (!value && value !== 0) {
      this.props.onChange(undefined);
    } else {
      this.props.onChange(value);
    }
  };

  render() {
    return (<InputNumber
      type="number"
      placeholder={this.props.placeholder}
      value={this.props.value}
      required={this.props.required}
      disabled={this.props.disabled}
      onChange={value => this.onChange(value)}
      style={{ width: '100%' }}
    />);
  }
}

export default InputNumberWidget;



// WEBPACK FOOTER //
// ./src/components/Form/Widgets/InputNumberWidget/index.js